import { c as _c } from "react/compiler-runtime";
import { Icon } from '@repo/design-system/components/ds/icon';
import { FlexColumn } from '@repo/design-system/components/layout/flex-column';
import { FlexRow } from '@repo/design-system/components/layout/flex-row';
import { Type } from '@repo/design-system/components/ui/type';
import { useT } from '@repo/i18n/components/i18n.client';
import { css } from '@repo/panda/css';
import type React from 'react';
import { useState } from 'react';
export type ChecklistFeedbackSource = 'explore-list' | 'checklist-subcategory' | 'custom-checklist-list' | 'hero-action-list';
export type ChecklistFeedbackType = 'positive' | 'negative';
interface ChecklistFeedbackProps {
  onRate: (type: ChecklistFeedbackType) => void;
}
const cardStyles = css.raw({
  padding: '20'
});
const thumbButtonBase = css({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '[24px]',
  height: '[24px]',
  background: 'transparent',
  border: 'none',
  padding: '0',
  cursor: 'pointer',
  borderRadius: '4',
  color: 'text.placeholder',
  transition: 'colors',
  _focusVisible: {
    outline: '[2px solid]',
    outlineColor: 'blue.500',
    outlineOffset: '2'
  }
});
const thumbUpStyles = css({
  _hover: {
    color: 'green.500'
  }
});
const thumbDownStyles = css({
  _hover: {
    color: 'red.400'
  }
});
export const ChecklistFeedback: React.FC<ChecklistFeedbackProps> = t0 => {
  const $ = _c(17);
  const {
    onRate
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["game_map"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useT(t1);
  const [submitted, setSubmitted] = useState(false);
  let t2;
  if ($[1] !== onRate || $[2] !== submitted) {
    t2 = type => {
      if (submitted) {
        return;
      }
      onRate(type);
      setSubmitted(true);
    };
    $[1] = onRate;
    $[2] = submitted;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const handleRate = t2;
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = css({
      textAlign: "center"
    });
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== submitted || $[6] !== t) {
    t4 = submitted ? t(_temp) : t(_temp2);
    $[5] = submitted;
    $[6] = t;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t4) {
    t5 = <Type variant="body-xs" color="text.placeholder" className={t3}>{t4}</Type>;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== handleRate || $[11] !== submitted || $[12] !== t) {
    t6 = !submitted && <FlexRow gap="none" align="center"><button type="button" aria-label={t(_temp3)} className={`${thumbButtonBase} ${thumbDownStyles}`} onClick={() => handleRate("negative")}><Icon fill={true} icon="thumb_down" size="sm" decorative={true} /></button><button type="button" aria-label={t(_temp4)} className={`${thumbButtonBase} ${thumbUpStyles}`} onClick={() => handleRate("positive")}><Icon fill={true} icon="thumb_up" size="sm" decorative={true} /></button></FlexRow>;
    $[10] = handleRate;
    $[11] = submitted;
    $[12] = t;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t5 || $[15] !== t6) {
    t7 = <FlexColumn align="center" gap="8" width="full" className={cardStyles}>{t5}{t6}</FlexColumn>;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
};
function _temp($) {
  return $.checklist_feedback_thanks;
}
function _temp2($_0) {
  return $_0.checklist_feedback_prompt;
}
function _temp3($_1) {
  return $_1.thumb_down_aria_label;
}
function _temp4($_2) {
  return $_2.thumb_up_aria_label;
}